import { colors } from "@/constants";
import styled, { keyframes } from "styled-components";

const animation = keyframes`
  from {
    opacity: 0;
    margin-left: -30px;
  }
  to {
    opacity: 1;
    margin-left: 0px;
  }
`;
export const InputContainer = styled.div<{ $animate?: boolean }>`
  display: flex;
  width: 100%;
  border-radius: 6px;
  flex-direction: row;
  align-items: center;
  padding: 18px 0;
  animation: ${({$animate}) => $animate ? animation : 'none'} 0.3s ease;
`;

export const Input = styled.input`
  width: 100%;
  height: 40px;
  border: none;
  margin-top: 10px;
  padding-left: 10px;
  background-color: ${colors.brand.white};
  border-radius: 6px;
`;

export const CancelButton = styled.button<{ $show: boolean }>`
  flex: none;
  border: none;
  padding: 0px;
  display: flex;
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.25s;
  color: ${colors.brand.white};
  opacity: ${(i) => (i.$show ? 1 : 0)};
  background-color: ${colors.transparent};
  margin-left: ${(i) => (i.$show ? 10 : 0)}px;
  max-width: ${(i) => (i.$show ? "100%" : "0px")};
`;